// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"41":"email","321":"core","493":"security","544":"preferences","685":"error"}[chunkId] || chunkId) + "." + {"41":"644f002d","321":"f2f085d2","350":"05607fe5","493":"90ae740e","544":"79c469ea","685":"8fc7aff6"}[chunkId] + ".js";
};